export default __webpack_public_path__ + "static/media/sleipner-pdf-bg.6d068b0a.png";